import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { updateProgram, getProgramById } from "api/program.api";
import ProgramForm from "components/program/ProgramForm";
import Toast from "components/Toast";
export default function EditProgram() {
  const { id } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [alert, setAlert] = useState("");
  const [toast, setToast] = useState({
    open: false,
    title: "",
    message: "",
    type: "success",
  });

  useEffect(() => {
    fetchProgram();
  }, []);

  const fetchProgram = async () => {
    try {
      const res = await getProgramById(id);
      setInitialData(res.data?.data || res.data);
    } catch (err) {
      console.error("Fetch failed", err);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = async (formData) => {
    try {
      await updateProgram(id, formData);
      setToast({
        open: true,
        title: "Success", 
        message: "Program updated successfully",
        type: "success",
      });
      // navigate("/admin/program");
    } catch (err) {
      console.error(err);
      setAlert(err.response?.data?.message || "Something went wrong");
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <>
      <Toast
        open={toast.open} 
        title={toast.title}
        message={toast.message}
        type={toast.type}
        duration={1500}
        onClose={() => {
          setToast((prev) => ({ ...prev, open: false }));
          navigate("/admin/program");
        }}
      />
    <ProgramForm
      initialData={initialData}
      onSubmit={handleSubmit}
      onBack={() => navigate("/admin/program")}
      alert={alert}
      setAlert={setAlert}
    />
    </>
  );
}